import { useState, useEffect } from 'react';
import { Input } from './ui/input';

const FR_RE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

const isoToFr = (value) => {
  if (!value) return '';
  if (FR_RE.test(value)) return value;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

const frToIso = (text) => {
  const m = FR_RE.exec(text);
  if (!m) return '';
  const [, d, mo, y] = m;
  const dt = new Date(Number(y), Number(mo) - 1, Number(d));
  if (dt.getFullYear() !== Number(y) || dt.getMonth() + 1 !== Number(mo) || dt.getDate() !== Number(d)) return '';
  return `${y}-${mo}-${d}`;
};

const mask = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join('/');
};

// Saisie de date au format JJ/MM/AAAA ; value/onChange en ISO (AAAA-MM-JJ). Une date invalide ne modifie pas la valeur.
export const DateInputFR = ({ value, onChange, className = '', ...props }) => {
  const [text, setText] = useState(isoToFr(value));
  const [touched, setTouched] = useState(false);
  const invalid = text !== '' && !frToIso(text) && (touched || text.length === 10);

  useEffect(() => {
    if (value) setText(prev => (frToIso(prev) === value ? prev : isoToFr(value)));
  }, [value]);

  const handleChange = (e) => {
    const t = mask(e.target.value);
    setText(t);
    const iso = frToIso(t);
    if (iso || t === '') onChange(iso);
  };

  return (
    <>
      <Input
        inputMode="numeric"
        placeholder="JJ/MM/AAAA"
        maxLength={10}
        value={text}
        onChange={handleChange}
        onBlur={() => setTouched(true)}
        className={`${className} ${invalid ? 'border-red-500' : ''}`}
        {...props}
      />
      {invalid && (
        <p className="text-red-500 text-xs mt-1" data-testid="date-input-fr-error">
          Date invalide : saisissez une date complète au format JJ/MM/AAAA
        </p>
      )}
    </>
  );
};

export default DateInputFR;
